module.exports = __webpack_public_path__ + "img/pr-8.59fed179.png";